import { render, staticRenderFns } from "./Jersey.vue?vue&type=template&id=1d9b59bb&"
import script from "./Jersey.vue?vue&type=script&lang=ts&"
export * from "./Jersey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports